var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{attrs:{"to":_vm.routerLink}},[_c('font-awesome-icon',{attrs:{"icon":['fas', 'times']}}),_vm._v(" Abbrechen ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }